import { useEffect } from 'react';
import { createUseStyles } from '@glu/theming';

const useStyles = createUseStyles({
  modalNoScroll: {
    overflow: 'hidden'
  }
});

function useBodyScrollLock(active) {
  const { modalNoScroll } = useStyles();

  useEffect(() => {
    if (active) {
      document.body.classList.add(modalNoScroll);
    } else {
      document.body.classList.remove(modalNoScroll);
    }
    return () => {
      document.body.classList.remove(modalNoScroll);
    };
  }, [active, modalNoScroll]);
}

export default useBodyScrollLock;
